import type { GetDisbursementPayoutBatchesParams } from 'api';

import type { GlobalFiltersState } from 'reduxLocal/slices/globalFiltersSlice';

import type { LocalState } from './localState';

type Params = LocalState & GlobalFiltersState & { organisationId: string };

export const apiParams = function (
  state: Partial<Params>
): GetDisbursementPayoutBatchesParams {
  const filter: {
    kind: 'csv';
    state?: string;
  } = { kind: 'csv' };

  if (state.filters?.status) {
    filter.state = state.filters.status;
  }

  // Build pagination params
  const pageParams = {
    ...(state.cursorBefore && { cursor_before: state.cursorBefore }),
    ...(state.cursorAfter && { cursor_after: state.cursorAfter }),
    ...(state.includeCursor && { include_cursor: state.includeCursor })
  };

  // Build sorting params
  const sortingParams = state.sorting?.trim() ? { sort: state.sorting } : {};

  // Build date range params
  const dateRangeParams = {
    ...(state.dateRange?.from && { created_after: state.dateRange.from }),
    ...(state.dateRange?.to && { created_before: state.dateRange.to })
  };

  return {
    'filter[kind]': filter.kind,
    'filter[state]': filter.state,
    'page[cursor_after]': pageParams.cursor_after,
    'page[cursor_before]': pageParams.cursor_before,
    'page[include_cursor]': pageParams.include_cursor,
    'page[size]': 50,
    sort: sortingParams.sort,
    created_after: dateRangeParams.created_after,
    created_before: dateRangeParams.created_before
  };
};
